import React from "react";
import { NavImageStyled } from "./NavImageStyles";
const NavImage = ({ src, height, alt = "nav-logo" }) => {
    return React.createElement(NavImageStyled, { src: src, height: height ?? "40px", alt: alt });
};
export default NavImage;
//# sourceMappingURL=NavImage.js.map